import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Inicio from './paginas/Inicio/Inicio';
import Pagina2 from './paginas/Inicio/Pagina2';
import Pagina3 from './paginas/Inicio/Pagina3';
import Login from './paginas/Inicio/Login';
import Entretenimento from './paginas/Inicio/Entretenimento';
import Planos from './paginas/Inicio/Planos';
import Internet from './paginas/Inicio/Internet';
import Empresas from './paginas/Inicio/Empresas';
import MonteoSeu from './paginas/Inicio/MonteoSeu';
import Perguntas from './paginas/Inicio/Perguntas';
import Carrinho from './componentes/comuns/Carrinho';
import ParceiroBranding from './componentes/ParceiroBranding/ParceiroBranding';
import Loading from './componentes/Loading/Loading';
import { initBranding } from './data/parceiros';

function App() {
  const [brandingLoaded, setBrandingLoaded] = useState(false);
  const [brandingConfig, setBrandingConfig] = useState(null);

  useEffect(() => {
    // Inicializa o sistema de branding
    const config = initBranding();
    setBrandingConfig(config);
    setBrandingLoaded(true);

    console.log('🎨 Branding inicializado:', config.client.name);
    console.log('🎨 Parceiro ID:', config.client.id);
  }, []);

  // Exibe loading enquanto branding carrega
  if (!brandingLoaded) {
    return <Loading />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Quemsomos" element={<Pagina2 />} />
        <Route path="/OfertasChips" element={<Pagina3 />} />
        <Route path="/Entretenimento" element={<Entretenimento />} />
        <Route path="/Planos" element={<Planos />} />
        <Route path="/Internet" element={<Internet />} />
        <Route path="/ParaEmpresas" element={<Empresas />} />
        <Route path="/MonteSeuPlano" element={<MonteoSeu />} />
        <Route path="/perguntasfrequentes" element={<Perguntas />} />
        <Route path="/carrinho" element={<Carrinho />} />
        
        {/* Rota de teste de branding */}
        <Route path="/branding-test" element={<ParceiroBranding />} />
      </Routes>
    </Router>
  );
}

export default App;
